module.exports = __webpack_public_path__ + "static/media/image10.51d154cf.jpg";